<template>
  <div class="price-editor center-ag-grid-editor">
    <RInput ref="input" :value="formattedValue" no-feedback-icon no-hint no-label on-clear="focus" @clear="clear" />
  </div>
</template>

<script>
import Cleave from 'cleave.js'

export default {
  name: 'PriceEditor',

  data: () => ({
    formattedValue: null,
    rawValue: null,
    cleave: null
  }),

  computed: {
    decimals() {
      return this.params.decimals ?? 2
    }
  },

  mounted() {
    const delimiter = this.settings.thousand_separator
    const price = this.params.value !== null ? Number(this.params.value).toFixed(this.decimals) : null

    this.cleave = new Cleave(this.$el.querySelector('input'), {
      numeral: true,
      numeralDecimalMark: this.settings.decimal_separator,
      delimiter: delimiter === 'space' ? ' ' : delimiter,
      numeralDecimalScale: this.decimals,
      onValueChanged: this.valueChanged
    })

    this.cleave.setRawValue(price)
    this.$nextTick(() => {
      this.$refs.input.focus()
      this.$refs.input.select()
    })
  },

  methods: {
    getValue() {
      if (!!this.rawValue.trim()) return Number(this.rawValue)
      return null
    },

    valueChanged({ target: { rawValue, value } }) {
      this.rawValue = rawValue
      this.formattedValue = value
    },

    clear() {
      this.formattedValue = this.rawValue = null
      this.cleave.setRawValue(null)
    }
  }
}
</script>
